import * as Yup from "yup";
import checkout from "./form2";

const {
  formField2: { taxAgencyId, taxAgencyName, taxpayerName, taxId },
} = checkout;

const validation2 = Yup.object().shape({
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
});

export default validation2;
